import { gql } from "@/gql";

export const InvitationData = gql(`
  fragment InvitationData on UserInvitation {
    id
    franchiseId
    salonId
    workerId
    token
    email
    firstName
    lastName
    invitedBy
    message
    generatedPassword
    generatedRawPassword
    passwordGenerated
    role
    status
    expiresAt
    acceptedAt
    createdAt
    salonName
    workerName
  }
`);
